<template>
    <div>
        <div>
            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;"><b>-仓库列表</b></p>

                <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                    <el-button round type="primary" @click="openDialog">新增仓库</el-button>
                    <span>-</span>
                </p>

            </div>

            <el-table :data="storeList" style="width: 100%" tooltip-effect="dark">
                <el-table-column type="index" width="40" fixed>
                </el-table-column>


                <el-table-column prop="storeCode" label="仓库编号" min-width="15%" fixed>
                </el-table-column>
                <el-table-column prop="storeName" label="仓库名称" min-width="25%" fixed>
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="235">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="success" round size="small">
                            编辑
                        </el-button>
                        <el-button @click="deleteClick(scope.row)" type="danger" round size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <!-- <div>
                <el-pagination background :page-size="cusPageNum" :page-count="cusPageCount"
                    layout="total, sizes, prev, pager, next" :total="cusTotal" @current-change="cusPageClick"
                    :page-sizes="[5, 10, 15, 20]" @size-change="hdlSizeChange">
                </el-pagination>
            </div> -->

            <el-dialog title="仓库详情" :visible.sync="dlgVisible" width="50%">
                <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm" label-width="110px">

                    <el-row>
                        <el-col :span="9">
                            <el-form-item label="仓库编号" required prop="storeCode">
                                <el-input v-model="form.storeCode" autocomplete="off" style="width:200px"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="15">
                            <el-form-item label="仓库名称" required prop="storeName">
                                <el-input v-model="form.storeName" autocomplete="off" style="width:400px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="dlgVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addStore('ruleForm')">保 存</el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
    name: "Store",
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),

            dlgVisible: false,

            form: {
                customerId: '',
                storeCode: '',

                storeName: ''
            },
            storeList: [],

            loading: false,

            cusPageIndex: 0,
            cusPageNum: 5,
            cusTotal: 0,
            cusPageCount: 0,

            pageIndex: 0,
            pageNum: 8,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        openDialog() {

            this.form.id = ''
            this.form.storeCode = ''
            this.form.storeName = ''

            this.dlgVisible = true
        },
        handleClick(row) {

            this.form.id = row.id
            this.form.storeCode = row.storeCode
            this.form.storeName = row.storeName

            this.dlgVisible = true
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeStore(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        removeStore(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/base/store/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAll()
            })
        },
        addStore() {

            this.$axios({
                method: "post",
                url: "/shiro/base/store/add",
                data: {
                    id: this.form.id,
                    storeCode: this.form.storeCode,
                    storeName: this.form.storeName,

                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message({
                    type: 'info',
                    message: data.msg
                })

                this.dlgVisible = false

                this.getAll()
            })
        },
        getAll() {
            this.$axios({
                method: "post",
                url: "/shiro/base/store/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.storeList = data.data
            })
        }
    },
    mounted() {
        this.setDefaultPath('/store')

        // 阻止默认行为
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };

        this.getAll()
    }
}
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}
</style>